import styled from "styled-components";
import bgRight from "assets/images/bg-right.png";
import { fonts } from "styles";

export const Container = styled.section`
  width: 100%;
  height: auto;
  min-height: 100vh;
  display: flex;
  position: relative;
  background: black;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;

  &.left {
    align-items: flex-end;
    justify-content: center;
    background: rgb(180, 58, 190);
    background: linear-gradient(
      130deg,
      rgba(180, 58, 190, 1) 0%,
      rgba(116, 36, 159, 1) 14%,
      rgba(41, 23, 158, 1) 80%,
      rgba(38, 22, 116, 1) 100%
    );
    max-width: 60%;
    padding: 48px 91px 48px 91px;
  }

  &.right {
    align-items: flex-start;
    justify-content: center;
    max-width: 40%;
    background: black url(${bgRight}) repeat;
    padding: 48px 48px 48px 72px;
  }

  @media screen and (max-width: 1024px) {
    &.left {
      padding: 48px;
    }
    &.right {
      padding: 48px;
      background: black;
    }
  }

  @media screen and (max-width: 960px) {
    height: auto;

    &.left {
      max-width: 100%;
      padding: 83px 20px 20px 20px;
    }
    &.right {
      max-width: 100%;
      padding: 30% 43px 126px 43px;
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;

  @media screen and (max-width: 960px) {
    margin-bottom: -25%;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 26px;
  line-height: 26px;
  color: white;
  text-transform: uppercase;
  width: 100%;
  margin-bottom: 24px;

  br {
    display: none;
  }

  @media screen and (max-width: 960px) {
    margin-bottom: 40px;
    font-size: 20px;
    line-height: 24px;
    padding-left: 24px;

    span {
      display: none;
    }

    br {
      display: block;
    }
  }
`;

export const Video = styled.div`
  width: 100%;
  position: relative;
  padding-top: 56.25%;

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 254px;

  @media screen and (max-width: 960px) {
    max-width: 100%;
  }
`;

export const Name = styled.h2`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 21px;
  line-height: 22px;
  color: #e865bc;
  margin-bottom: 8px;

  @media screen and (max-width: 960px) {
    font-size: 18px;
  }
`;

export const Profile = styled.h6`
  font-family: ${fonts.BentonSansWide};
  font-size: 15px;
  line-height: 20px;
  color: white;
  margin-bottom: 32px;

  @media screen and (max-width: 960px) {
    font-size: 14px;
  }
`;

export const Text = styled.article`
  width: 100%;
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 22px;
  color: white;
  max-width: 224px;

  @media screen and (max-width: 960px) {
    max-width: 100%;
  }
`;
